<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { messageTimestamp } from 'shared/helpers/timeHelper';
import Icon from 'next/icon/Icon.vue';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { content, createdAt } = useMessageContext();
const { locale, t } = useI18n();

const currentLocale = computed(
  () =>
    window.chatwootConfig?.selectedLocale ||
    document?.documentElement?.lang ||
    locale.value ||
    'es'
);

const readableTime = computed(() =>
  messageTimestamp(createdAt.value, 'LLL d, h:mm a', currentLocale.value)
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1.5 !rounded-xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span
      class="inline-flex items-center gap-1 rounded-full bg-n-solid-1 px-2 py-0.5 text-[11px] font-semibold tracking-[0.02em] text-n-slate-11"
    >
      <Icon icon="i-lucide-sparkles" class="size-3" />
      {{ t('CONVERSATION.MESSAGE_ROLE.SYSTEM') }}
    </span>
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
